import { getFormValues } from 'redux-form'
import { isFieldActive } from 'selectors/redux-form'
import { CHANGE_PASSWORD_FORM, NEW_PASSWORD_PROPERTY } from './constants'

export const getChangePasswordFormValues = getFormValues(CHANGE_PASSWORD_FORM)
export const isNewPasswordActive = isFieldActive(CHANGE_PASSWORD_FORM, NEW_PASSWORD_PROPERTY)

export const isNewPasswordDirty = state => {
  const values = getChangePasswordFormValues(state)

  return values && values[NEW_PASSWORD_PROPERTY]
}
